import React, { useState } from 'react';
import MessageBox from 'components/generic-components/messages/MessageBox';
import { useTranslation } from 'react-i18next';
import ButtonComponent from 'components/generic-components/ButtonComponent';
import { ClipIcon, DeleteIcon } from 'components/Icons';
import MessageInput from 'components/generic-components/MessageInput';
import { ReactComponent as SendButtonInactive } from 'images/send-message-inactive.svg';
import { ReactComponent as SendButtonActive } from 'images/send-message-active.svg';
import { selectAuthUser } from 'reducers/auth/auth.selectors';
import { useSelector } from 'react-redux';
import AddPaymentModal from 'components/AddPaymentModal';
import TipModal from 'components/TipModal';

const SendMessage = () => {
    const { t } = useTranslation();
    const user = useSelector(selectAuthUser);
    const [attachment, setAttachment] = useState([]);
    const [message, setMessage] = useState('');
    const [subscribed, setSubscribed] = useState(false);
    const ref = React.createRef();

    const handleFileSelect = e => {
        const file = e.target.files[0];
        if (attachment.length === 10) return;
        setAttachment(prevState => [...prevState, { file, url: URL.createObjectURL(file) }]);
    };

    const handleFileDelete = url => {
        setAttachment(attachment.filter(attach => attach.url !== url));
    };

    const handleMessageInput = event => {
        setMessage(event?.target?.value);
    }

    const handleSendMessage = () => {
        setMessage('');
        // TODO here we should dispatch an action, that will write message in the DB
    }

    return (
        <div className={'d-flex flex-column px-3 h-100 send-message-container'}>
            <div className="d-flex flex-column mt-4 send-message-upper-container">

                <MessageBox showDots={false}>
                    <div className={'font-size-12 text-light'}>
                        {
                            !subscribed ?
                                <>
                                    {t('If you you wont to send message to this artist')}
                                    <br />
                                    <br />
                                    {t('please subscribe!')}
                                </> :
                                t('Thank you for your subscription!')
                        }

                    </div>
                </MessageBox>

                {
                    !subscribed &&
                    <div className={'d-flex justify-content-between align-items-center mt-5 subscription-container'}>
                        <div className={"font-size-12 text-light subscription-amount"}>
                            {t('Subscription 10$ per month')}
                        </div>
                        <TipModal user={user} buttonContent={
                            <ButtonComponent
                                type={'button'}
                                btnText={t('Subscribe')}
                                transparent={true}
                                bordered={true}
                                customClass={'btn-transparent subscribe-button button-bordered-pink'}
                                textClassName={'p-2 text-pink font-size-12 font-weight-normal subscribe-text'}
                            />
                        } />
                    </div>
                }

            </div>

            <div className={'d-flex flex-column send-message-content-container'}>

                {
                    attachment.length > 0 ?
                        <div className="attachmant-wrapper">
                            {attachment?.map((file, index) => {
                                return (
                                    <div
                                        className="d-flex align-items-end justify-content-end "
                                        style={{ marginRight: 18, marginBottom: 16 }}
                                        key={`image_${index}`}
                                    >
                                        <img src={file.url} width={64} height={64} alt="attachemnts" style={{ borderRadius: 8 }} />
                                        <div style={{ position: 'relative' }}>
                                            <button
                                                className="delete-button"
                                                onClick={() => {
                                                    handleFileDelete(file.url);
                                                }}
                                            >
                                                <DeleteIcon />
                                            </button>
                                        </div>
                                    </div>
                                );
                            })}
                        </div> :
                        null
                }

                <div className={'d-flex textarea-block-container justify-content-between align-items-start'}>
                    <MessageInput
                        wrapperClass={'message-input-wrapper'}
                        uploadType="file"
                        customClass="main-input"
                        onChange={e => handleFileSelect(e)}
                        ref={ref}
                        attachment={attachment}
                        handleFileDelete={e => handleFileDelete(e)}
                        UploadIcon={ClipIcon}
                        mediaTypes=".jpg,.jpeg,.webp,.gif,.bmp,.png"
                        showLabel={false}
                        disabled={!subscribed}
                    />

                    <div className={`input-wrapper 
           ${attachment.length > 0 ? 'input-wrapper-with-attachement' : 'input-wrapper-no-attachment'}`}>
                        <div className={'textarea-container'}>
                            <textarea
                                disabled={!subscribed}
                                className={"text-area message-textarea px-5 font-size-12 text-light pt-3"}
                                value={message}
                                rows="2"
                                onChange={handleMessageInput}
                                placeholder={'Type message'} />
                        </div>
                    </div>

                    <button
                        type={'submit'}
                        disabled={!subscribed}
                        onClick={handleSendMessage}
                        style={{
                            backgroundColor: 'transparent',
                            zIndex: 100
                        }} className={'pt-3'}>
                        {
                            (attachment.length > 0 || message.length > 0) ?
                                <SendButtonActive width={20} /> :
                                <SendButtonInactive width={20} />
                        }
                    </button>

                </div>
            </div>
        </div>
    )
}

export default SendMessage;
